export default [
    {
        "title": "Unterstützung der Ukraine",
        "text": "Deutschland soll die Ukraine weiterhin militärisch unterstützen."
    },
    {
        "title": "Erneuerbare Energien",
        "text": "Der Ausbau erneuerbarer Energien soll weiterhin vom Staat finanziell gefördert werden."
    },
    {
        "title": "Streichung des Bürgergelds",
        "text": "Das Bürgergeld soll denjenigen gestrichen werden, die wiederholt Stellenangebote ablehnen."
    },
    {
        "title": "Tempolimit auf Autobahnen",
        "text": "Auf allen Autobahnen soll ein generelles Tempolimit gelten."
    },
    {
        "title": "Abweisung Asylsuchender",
        "text": "Asylsuchende, die über einen anderen EU-Staat eingereist sind, sollen an den deutschen Grenzen abgewiesen werden."
    },
    {
        "title": "Begrenzung der Mietpreise",
        "text": "Bei Neuvermietungen sollen die Mietpreise weiterhin gesetzlich begrenzt werden."
    },
    {
        "title": "Automatisierte Gesichtserkennung",
        "text": "An Bahnhöfen soll die Bundespolizei Software zur automatisierten Gesichtserkennung einsetzen dürfen."
    },
    {
        "title": "Energieintensive Unternehmen",
        "text": "Energieintensive Unternehmen sollen vom Staat einen finanziellen Ausgleich für ihre Stromkosten erhalten."
    },
    {
        "title": "Rente nach 40 Beitragsjahren",
        "text": "Alle Beschäftigten sollen bereits nach 40 Beitragsjahren ohne Abschläge in Rente gehen können."
    },
    {
        "title": "Grundgesetz",
        "text": "Im einleitenden Satz des Grundgesetzes soll weiterhin die Formulierung „Verantwortung vor Gott“ stehen."
    },
    {
        "title": "Anwerbung von Fachkräften",
        "text": "Deutschland soll weiterhin die Anwerbung von Fachkräften aus dem Ausland fördern."
    },
    {
        "title": "Nutzung der Kernenergie",
        "text": "Für die Stromerzeugung soll Deutschland wieder Kernenergie nutzen."
    },
    {
        "title": "Anhebung des Spitzensteuersatzes",
        "text": "Bei der Besteuerung von Einkommen soll der Spitzensteuersatz angehoben werden."
    },
    {
        "title": "Kompetenzen in der Schulpolitik",
        "text": "Der Bund soll mehr Kompetenzen in der Schulpolitik erhalten."
    },
    {
        "title": "Rüstungsexporte nach Israel",
        "text": "Aus Deutschland sollen weiterhin Rüstungsgüter nach Israel exportiert werden dürfen."
    },
    {
        "title": "Krankenkassen",
        "text": "Alle Bürgerinnen und Bürger sollen in gesetzlichen Krankenkassen versichert sein müssen."
    },
    {
        "title": "Abschaffung der Frauenquote",
        "text": "Die gesetzliche Frauenquote in Vorständen und Aufsichtsräten börsennotierter Unternehmen soll abgeschafft werden."
    },
    {
        "title": "Ökologische Landwirtschaft",
        "text": "Ökologische Landwirtschaft soll stärker gefördert werden als konventionelle Landwirtschaft."
    },
    {
        "title": "Projekte gegen Rechtsextremismus",
        "text": "Der Bund soll Projekte gegen Rechtsextremismus verstärkt fördern."
    },
    {
        "title": "Kontrolle von Zulieferern",
        "text": "Unternehmen sollen weiterhin die Einhaltung der Menschenrechte und des Umweltschutzes bei allen Zulieferern kontrollieren müssen."
    },
    {
        "title": "Elternabhängiges BAföG",
        "text": "Die Ausbildungsförderung BAföG soll weiterhin abhängig vom Einkommen der Eltern gezahlt werden."
    },
    {
        "title": "Schuldenbremse",
        "text": "Die Schuldenbremse im Grundgesetz soll beibehalten werden."
    },
    {
        "title": "Arbeitserlaubnis für Asylsuchende",
        "text": "Asylsuchende sollen in Deutschland sofort nach ihrer Antragstellung eine Arbeitserlaubnis erhalten."
    },
    {
        "title": "Verwerfen der Klimaziele",
        "text": "Deutschland soll das Ziel verwerfen, klimaneutral zu werden."
    },
    {
        "title": "35-Stunden-Woche",
        "text": "In Deutschland soll die 35-Stunden-Woche als gesetzliche Regelarbeitszeit für alle Beschäftigten festgelegt werden."
    },
    {
        "title": "Schwangerschaftsabbruch nach Beratung",
        "text": "Schwangerschaftsabbrüche sollen in den ersten drei Monaten weiterhin nur nach Beratung straffrei sein."
    },
    {
        "title": "Nationale Währung",
        "text": "Der Euro soll in Deutschland durch eine nationale Währung ersetzt werden."
    },
    {
        "title": "Schiene vor Straße",
        "text": "Beim Ausbau der Verkehrsinfrastruktur soll die Schiene Vorrang vor der Straße haben."
    },
    {
        "title": "Ehrenamt",
        "text": "Ehrenamtliche Tätigkeiten sollen auf die zukünftige Rente angerechnet werden."
    },
    {
        "title": "Umlegung der Grundsteuer",
        "text": "Die Grundsteuer soll weiterhin auf Mieterinnen und Mieter umgelegt werden dürfen."
    },
    {
        "title": "Einschränkung des Streikrechts",
        "text": "Das Streikrecht für Beschäftigte in Unternehmen der kritischen Infrastruktur soll gesetzlich eingeschränkt werden."
    },
    {
        "title": "Volksentscheide",
        "text": "In Deutschland soll es auf Bundesebene Volksentscheide geben können."
    },
    {
        "title": "Strafrecht für unter 14-Jährige",
        "text": "Unter 14-Jährige sollen strafrechtlich belangt werden können."
    },
    {
        "title": "Abschaffung von Zöllen",
        "text": "Deutschland soll sich für die Abschaffung der erhöhten EU-Zölle auf chinesische Elektroautos einsetzen."
    },
    {
        "title": "Zweite Staatsbürgerschaft",
        "text": "In Deutschland soll es weiterhin generell möglich sein, neben der deutschen eine zweite Staatsbürgerschaft zu haben."
    },
    {
        "title": "Soziales Pflichtjahr",
        "text": "Für junge Erwachsene soll ein soziales Pflichtjahr eingeführt werden."
    },
    {
        "title": "Fossile Brennstoffe",
        "text": "Neue Heizungen sollen auch zukünftig vollständig mit fossilen Brennstoffen (z. B. Gas oder Öl) betrieben werden dürfen."
    },
    {
        "title": "Erhöhung des Mindestlohns",
        "text": "Der gesetzliche Mindestlohn soll spätestens 2026 auf 15 Euro erhöht werden."
    }
];
